import React from "react";
import ForgotPassword from "./component/ForgotPasswordForm";
import ActivateLogo from "../../../assets/images/activate-logo.svg";
import { styled } from "@mui/system";
import { Box, Typography } from "@mui/material";

const ForgotPasswordPage = () => {
  // return <ForgotPassword />;

  return (
    <SectionWrap component="section">
      <ContainerWrap>
        <RowWrap>
          <Col12Wrap sx={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src={ActivateLogo}
              alt="Activate Logo"
              width="238"
              height="90"
            />
          </Col12Wrap>
          <Col12Wrap>
            <FormFirstBoxWrap>
              <TitleWrap>Forgot Password</TitleWrap>
            </FormFirstBoxWrap>
          </Col12Wrap>
          <Col12Wrap>
            <ForgotPassword />
          </Col12Wrap>
        </RowWrap>
      </ContainerWrap>
    </SectionWrap>
  );
};

export default ForgotPasswordPage;

const SectionWrap = styled(Box)(() => ({
  padding: "30px 0 100px",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1170px",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const FormFirstBoxWrap = styled(Box)(() => ({
  padding: "20px 150px",
  background: "#ffffff",
  maxWidth: "1030px",
  borderTop: "2px solid #1085AB",
  borderRadius: "7px 7px 0px 0px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  textAlign: "center",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const TitleWrap = styled(Typography)(() => ({
  fontSize: "28px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#000000",
}));
